import { render, staticRenderFns } from "./BusStudentTrackingTable.vue?vue&type=template&id=a8bee530&scoped=true&"
import script from "./BusStudentTrackingTable.vue?vue&type=script&lang=js&"
export * from "./BusStudentTrackingTable.vue?vue&type=script&lang=js&"
import style0 from "./BusStudentTrackingTable.vue?vue&type=style&index=0&id=a8bee530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bee530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
